const baseUrl = `https://nurn.fieldcontrol.com.br`
let _accessToken = null;
const Api = {

  setAccessToken: (accessToken) => {
    _accessToken = accessToken
  },

  getLatestPosts: (publishedBefore) => {
    const requestUrl = `${baseUrl}/posts/latest?type=sidebar${publishedBefore ? `&publishedBefore=${publishedBefore}`: ''}`
    return fetch(requestUrl, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${_accessToken}`
      }
    }).then(res => res.json())
  },

  markUserAsSeen: () => {
    const requestUrl = `${baseUrl}/me/seen`
    return fetch(requestUrl, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${_accessToken}`
      }
    }).then(res => res.json())
  },

  getUserUnseenPostsCount: () => {
    const requestUrl = `${baseUrl}/me/count-unseen`
    return fetch(requestUrl, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${_accessToken}`
      }
    }).then(res => res.json())
  },

  getAccessToken: ({ 
    app,
    user
  }) => {
    return fetch(`${baseUrl}/apps/${app.id}/authenticate`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${_accessToken}`
      },
      body: JSON.stringify(user)
    }).then(res => res.json())
  },

  sendPostFeedbackMessage: ({
    postId,
    feedbackMessage
  }) => {
    return fetch(`${baseUrl}/posts/${postId}/feedback`, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${_accessToken}`
      },
      body: JSON.stringify({
        message: feedbackMessage,
      })
    }).then(res => res.json())
  },

  sendPostFeedbackReaction: ({
    postId,
    feedbackReaction
  }) => {
    return fetch(`${baseUrl}/posts/${postId}/feedback`, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${_accessToken}`
      },
      body: JSON.stringify({
        reaction: feedbackReaction
      })
    }).then(res => res.json())
  }

}
export default Api;